export default "__VITE_ASSET__Bu02CUZF__"